/**
 * XState v5 navigation state machine.
 *
 * Seven states, each corresponding 1:1 to a camera rig (mounted by NavController):
 *   idle → boarding → streetcarRiding → arrivalCinematic → freeWalk
 *   freeWalk ↔ guidedTour    (SELECT_TOUR / EXIT_TOUR)
 *   freeWalk ↔ photoCompare  (OPEN_COMPARE / CLOSE_COMPARE)
 *   freeWalk → streetcarRiding (REBOARD — skip boarding + arrival for quick trips back)
 *
 * Source: 03-RESEARCH.md Pattern 1 — used verbatim.
 * API: v5 `setup().createMachine()` (NOT v4 `Machine()`) per Pitfall #6.
 */

import { setup } from 'xstate';

export const navMachine = setup({
  types: {
    context: {} as {
      cameraPosition: [number, number, number];
      cameraQuaternion: [number, number, number, number];
    },
    events: {} as
      | { type: 'START' }
      | { type: 'BOARDED' }
      | { type: 'END_OF_LINE' }
      | { type: 'ARRIVAL_DONE' }
      | { type: 'SELECT_TOUR'; tourId: string }
      | { type: 'EXIT_TOUR' }
      | { type: 'OPEN_COMPARE' }
      | { type: 'CLOSE_COMPARE' }
      | { type: 'REBOARD' },
  },
}).createMachine({
  id: 'nav',
  initial: 'idle',
  context: {
    cameraPosition: [0, 1.7, 0],
    cameraQuaternion: [0, 0, 0, 1],
  },
  states: {
    idle: { on: { START: 'boarding' } },
    // Plan 05-01 Task 1 — declarative `after: 1500` replaces the Phase 3
    // bootedRef setTimeout cascade. The BoardingOverlay's "Board the
    // streetcar" click dispatches START; the machine self-advances after
    // 1500ms (matching the streetcar-bell moment + browser autoplay-gesture
    // unlock). The explicit BOARDED event is retained for programmatic /
    // test-only fast-forward.
    boarding: {
      on: { BOARDED: 'streetcarRiding' },
      after: { 1500: { target: 'streetcarRiding' } },
    },
    streetcarRiding: { on: { END_OF_LINE: 'arrivalCinematic' } },
    arrivalCinematic: { on: { ARRIVAL_DONE: 'freeWalk' } },
    freeWalk: {
      on: {
        SELECT_TOUR: 'guidedTour',
        OPEN_COMPARE: 'photoCompare',
        REBOARD: 'streetcarRiding',
      },
    },
    guidedTour: { on: { EXIT_TOUR: 'freeWalk' } },
    photoCompare: { on: { CLOSE_COMPARE: 'freeWalk' } },
  },
});
